$(window).on('load', function() {
  setTimeout(function(){
    $('body').removeClass('loading');
  }, 500);
});
